import axios from "../apis/django.instance";

export const getActivityTypeService = () => {
  return axios.get("/api/activities/activity_type/"); // must be in this format in order to mock implementation in unit test
};
